<template>
  <div>
    <div class="loadingBg" v-if="loading"></div>
    <div class='cusLayer full init-address' id='app'>
      <div class='cusHd'>
        <div class='row borer_bottom'>
          <div class='col w100p'><h1 class='tit'>{{$t('searchAddress')}}</h1></div>
          <div class='col col3'>
            <button type='button' class='btnCloseModal' v-if="osCheck" @click='appClose()'>
              종료
            </button>
          </div>
        </div>
      </div>
      <div class='cusCnt'>
        <div class='address_Top'>
          <p class='address_Tit'>{{$t('typeinAddress1')}}<br>{{$t('typeinAddress2')}}</p>
          <div class='address_Search'>
            <div class='address_Search_input'>
              <input v-model='keyword' type='text'
                :placeholder="$i18n.locale == 'ko' ? '예) 종로구 인사동길' : 'ex) Insa-dong, Jongno-gu'" class='input'
                @keyup.enter='onClickSearchBtn()'
                @input='onCheckInput'
                enterkeyhint="search"/>
              <button v-if='keyword.length > 0' type='button'
                class='btn del' @click='keyword = ""'/>
            </div>
            <div class='address_Search_Btn'>
              <button type='button' class='Btn'
                @click='onClickSearchBtn()'/>
            </div>
          </div>
          <!-- TODO 내위치 찾기 시 주석 해제 -->
          <SearchMyPosition />
        </div>
        <div v-if="appFlag">
          <div v-if="searchFlag" style="height: calc(100vh - 205px);">
            <div v-if='searchAddress.length > 0' class='address_List'>
              <div v-for='(juso, index) in searchAddress' :key='index' class='address_List_area'>
                <div class='list_Detail' @click.stop.prevent='chooseAddress(juso)'>
                  <p>{{juso.jibunAddr}}</p>
                  <span class='list_Detail_box'>도로명</span>
                  <span class='list_Detail_tit'>{{juso.roadAddr}}</span>
                </div>
              </div>
              <InfiniteLoading v-if='!lastPageFlag' @infinite='reqNextPage'/>
            </div>
            <div v-else class='noData address_Nodata'>
              <div class='in'>
                <span>해당 내역이 없습니다</span>
              </div>
            </div>
          </div>
          <div class="addressListWrap" v-if="addressList.length > 0">
            <div class="addressList" :class="{mainAddress: list.mainFlag}" v-for="(list, index) in addressList" :key="index" @click="setMainAddress(list)">
              <div class="addressIcon" :class="addressIcon[list.addressType ? list.addressType : 2]"></div>
              <h2 class="addressName">{{list.addressAlias ? list.addressAlias : list.jibunAddr}}
                <div class="checkIco" v-if="list.mainFlag"></div>
              </h2>
              <p>{{list.roadAddr + ' '}}{{list.detailAddress == undefined ? '' : list.detailAddress}}</p>
              <div class="addressBtns">
                <div @click.stop="addressDetailUpdate(index)">수정</div>
                <div @click.stop="openModal(index)" v-if="!list.mainFlag">삭제</div>
              </div>
            </div>
          </div>
          <div class='noData address_Nodata' v-else>
            <div class='in'><p>등록된 주소지가 없습니다.</p></div>
          </div>
        </div>
        <div v-else>
          <div v-if="searchFlag" style="height: calc(100vh - 205px);">
            <div v-if='searchAddress.length > 0' class='address_List'>
              <div v-for='(juso, index) in searchAddress' :key='index' class='address_List_area'>
                <div class='list_Detail' @click.stop.prevent='chooseAddress(juso)'>
                  <p>{{juso.jibunAddr}}</p>
                  <span class='list_Detail_box'>도로명</span>
                  <span class='list_Detail_tit'>{{juso.roadAddr}}</span>
                </div>
              </div>
              <InfiniteLoading v-if='!lastPageFlag' @infinite='reqNextPage'/>
            </div>
            <div v-else class='noData address_Nodata'/>
          </div>
          <div v-else-if='recentAddress.length > 0' class='address_List latest'>
            <p class='address_Txt'>최근주소</p>
            <div v-for='(address, index) in recentAddressArr' :key='index' class='address_List_area'>
              <div class='list_Detail' @click='onClickRecentAddress(address)'>
                <p>{{address.jibunAddr}}</p>
                <span class='list_Detail_box'>도로명</span>
                <span class='list_Detail_tit' v-if="$i18n.locale == 'ko'">{{address.roadAddrPart1 ? address.roadAddrPart1 : address.roadAddr}}</span>
                <span class='list_Detail_tit' v-else>{{address.roadAddr}}</span>
              </div>
              <div class='list_Detail_btn'>
                <button type='button' class='btn_Close'
                  @click='deleteRecentAddress(index)'/>
              </div>
            </div>
          </div>
          <div v-else class='noData address_Nodata'>
              <div class='in'><p>최근 입력된 주소가 없습니다.</p></div>
          </div>
        </div>
      </div>
    </div>
    <AddressDetail
      :selectAddress.sync="selectAddress"
      :position.sync="position"
      :addressLength="addressList.length"
      :homeActiveFlag.sync="homeActiveFlag"
      :updateType.sync="updateType"
      :recentAddress="recentAddress"
      @addresslist="getPrevAddresslist"
      @moveGroup="moveGroup"
      @onClickCloseBtn="onClickCloseBtn"
    />
    <DoubleBtnDialog
      v-if='showDoubleBtnDialogFlag'
      :message='doubleBtnMsgType'
      :onClickConfirmBtn='onClickConfirmBtn'
      :onClickCancelBtn='onClickCancelBtn'
      :imgFlag='false'/>
    <MyLocation />
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import DoubleBtnDialog from '@/components/Dialog/DoubleBtnDialog.vue'
import { MESSAGE_DOUBLE_BUTTON } from '@/utils/Message'
import service from '@/backend/modnpay_app_api'
import MyLocation from './MyLocation.vue'
import AddressMixins from '@/utils/AddressMixins.js'
import SearchMyPosition from '@/components/Geolocation/SearchMyPosition.vue'
import AddressDetail from '@/components/App/AddressDetail.vue'
import { APP_MAIN_NAME, HOTEL_SERVICE_NAME } from '@/utils/EndPoint'

export default {
  components: {
    DoubleBtnDialog, InfiniteLoading, MyLocation, SearchMyPosition, AddressDetail
  },
  mixins: [AddressMixins],
  data () {
    return {
      showDoubleBtnDialogFlag: false,
      onClickConfirmBtn: undefined,
      onClickCancelBtn: undefined,
      addressList: {},
      appFirstFlag: false,
      detailAddress: '', // 상세주소
      detailAddress2: '', // 오더그룹의 결제코드와 매핑되어있는 상세주소
      address: '',
      addressByRoadName: '', // 그룹QR 주소
      addressByLotNum: '', // 지번주소
      groupQrData: {},
      // orderGroupFixedCode: '', // 도로명주소
      // orderGroupSeq: '', // 그룹QR 시퀀스 번호
      // orderGroupName: '', // 그룹명
      // roomServiceUseYn: '',
      // storeCode: '',
      // isFixedAddress: '',
      loading: true,
      osCheck: false
    }
  },
  mounted () {
    // iPhone, iPad, iPod 중 하나라도 포함되어 있으면 iOS로 판단
    if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
      this.osCheck = true
    }
    sessionStorage.setItem('groupUrl', window.location.href)
    if (this.appFlag) {
      this.getPrevAddresslist()
    } else {
      // sessionStorage.setItem('groupUrl', window.location.href)
      // this.fastPopUp('#app.cusLayer')
      // 호텔 서비스 분기
      this.getParameter()
    }
    setTimeout(() => {
      if (window.__wxjs_environment === 'miniprogram') {
        this.$i18n.locale = 'cn'
        sessionStorage.setItem('langType', 'cn')
        document.title = 'MODNPAY智慧点餐'
      }
    }, 0)
  },
  methods: {
    async getPrevAddresslist () { // 주소목록 조회
      const req = {}
      const { data } = await service.addresslist(req)
      if (data.resultCode === 0) {
        this.addressList = data.addressList
        this.homeFlag = data.addressList.map(item => item.addressType).includes(0)

        const checkQuery = this.$route.query.check

        if (this.addressList.length !== 0 && !checkQuery) {
          if (this.$route.name !== 'AppMain') {
            try {
              await this.appMoveMain()
            } catch (err) {
              if (err.name !== 'NavigationDuplicated') {
                console.log(err.name)
                throw err
              }
            }
          }
        } else {
          this.loading = false
        }
      }
    },
    // ㅡㅡㅡㅡㅡㅡㅡㅡㅡ GROUP QR ㅡㅡㅡㅡㅡㅡㅡㅡㅡ //
    getParameter () { // 그룹QR 스캔 후 파라미터 가져오기
      const currentURL = window.location.href // URLSearchParams 객체 생성
      const params = new URLSearchParams(new URL(currentURL).search) // 파라미터 추출

      this.groupQrData = {
        orderGroupSeq: params.get('orderGroupSeq'),
        orderGroupFixedCode: params.get('orderGroupFixedCode'),
        orderGroupName: params.get('orderGroupName'),
        storeCode: params.get('storeCode'),
        roomServiceUseYn: params.get('roomServiceUseYn'),
        isFixedAddress: params.get('isFixedAddress'),
        taxiCallUseYn: params.get('taxiCallUseYn')
      }

      // 객체를 JSON 문자열로 변환
      const groupQrDataString = JSON.stringify(this.groupQrData)

      // sessionStorage에 저장
      sessionStorage.setItem('GroupQrData', groupQrDataString)

      // isFixedAddress == true 이면 그대로 진행 > AddressDetail에서 주소선택
      // isFixedAddress == false 이면 api로 주소저장
      if (this.groupQrData.isFixedAddress == 'Y') {
        this.callCategoryList()
      } else {
        this.loading = false
      }
    },
    async callCategoryList () { // 카테고리 및 주소 조회
      const req = {
        orderGroupSeq: this.groupQrData.orderGroupSeq,
        orderGroupFixedCode: this.groupQrData.orderGroupFixedCode
      }
      const { data } = await service.categoryList(req)

      if (data.resultCode == '0000000') { // 성공
        this.addressByRoadName = data.addressByRoadName // 도로명
        this.addressByLotNum = data.addressByLotNum // 지번
        this.detailAddress = data.detailAddress // 상세
        this.detailAddress2 = data.detailAddress2 // 오더그룹의 결제코드와 매핑되어있는 상세주소
        if (this.addressByRoadName || this.addressByLotNum) {
          this.groupQrAddressSearch()
        } else {
          this.loading = false
        }
      }
    },
    groupQrAddressSearch () { // 주소 검색
      const reqSearchAddress = {
        keyword: this.addressByRoadName ? this.addressByRoadName : this.addressByLotNum,
        pageNo: 1
      }
      this.$store.dispatch('reqSearchAddress', reqSearchAddress)
        .then((responsedData) => {
          this.address = responsedData.juso[0]
          this.address.detailAddress = this.detailAddress
          this.address.detailAddress2 = this.detailAddress2
          this.groupQrgetGPS(responsedData.juso[0])
        })
    },
    groupQrgetGPS (address) { // 해당 주소 좌표계 요청
      this.$store.dispatch('reqAddressPos', address)
        .then((responsedData) => {
          const position = this.getGPS(responsedData.juso)
          this.address.x = position.x
          this.address.y = position.y
          sessionStorage.setItem('selectAddress', JSON.stringify(this.address))
          this.moveGroup(this.addressByLotNum)
        })
    },
    moveGroup (addressEmdNm) {
      console.log('## moveGroup')
      this.removePopUp()
      const query = {
        addressByLotNum: addressEmdNm // 지번주소
      }
      let name = APP_MAIN_NAME
      if (this.groupQrData.roomServiceUseYn === 'Y' || this.groupQrData.taxiCallUseYn === 'Y') {
        name = HOTEL_SERVICE_NAME
      }
      this.$router.push({
        name,
        query
      })
    },
    showDoubleBtnDialog (message, confirmBtn) { // double btn show
      this.doubleBtnMsgType = message
      this.onClickConfirmBtn = confirmBtn
      this.onClickCancelBtn = this.hideDoubleBtnDialog
      this.showDoubleBtnDialogFlag = true
    },
    hideDoubleBtnDialog () {
      this.showDoubleBtnDialogFlag = false
    },
    appClose () {
      const alertMsg = MESSAGE_DOUBLE_BUTTON[12]
      this.showDoubleBtnDialog(alertMsg, () => {
        this.closeOrderApp()
        this.hideDoubleBtnDialog()
      })
    }
  }
}
</script>

<style scoped>
.btn-search {
  padding: 1rem 0;
  cursor: pointer;
  width: 100%;
  border: 1px solid var(--primary);
  color: var(--primary);
  font-weight: bold;
  margin-top: 0.8rem;
      display: flex;
    align-items: center;
    justify-content: center;
}

.btn-search span{
    position: relative;
    padding-left: 3rem;
}
.btn-search::before{
    background-image: url('../assets/img/ic-gps.svg');
    content: '';
    position: absolute;
    width: 2.2rem;
    height: 2.2rem;
    background-size: 2.2rem;
    margin-left: -9rem;
}
.init-address {
  bottom: 0px;
}
</style>
